import player from './player'

const setEnvironment = function (settings) {
  // let api = player.getApi()
  // if (api) {
  //   console.log('settings', settings)
  //   api.setEnvironment(settings, function () {
  //     if (callback != null) callback()
  //   })
  //   api.setEnvironment(settings, function () {
  //     if (callback != null) callback()
  //   })
  // }
  return new Promise((resolve, reject) => {
    let api = player.getApi()
    if (api) {
      api.setEnvironment(settings, function (err) {
        if (err) {
          reject(err)
        } else {
          resolve()
        }
      })
    } else {
      reject(new Error('API not found'))
    }
  })

}

const setBackground = function (settings, callback) {
  let api = player.getApi()
  if (api) {
    api.setBackground(settings, function () {
      if (callback != null) callback()
    })
  }
}

// Function seems deprecated
const getEnvironmentList = function () {
  let api = player.getApi()
  if (api) {
    api.getEnvironmentList(function (list) {
      console.log(list)
    })
  }
}

const getEnvironment = function () {
  let api = player.getApi()
  if (api) {
    api.getEnvironment(function (err, state) {
      if (err) {
        console.log(err)
      } else {
        console.log(state)
      }
    })
  }
}

window.configuratorapi.getEnvironmentList = getEnvironmentList
window.configuratorapi.getEnvironment = getEnvironment
window.configuratorapi.setEnvironment = setEnvironment

export default { setEnvironment, getEnvironment, getEnvironmentList, setBackground }
